"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackingStateRaw = void 0;
const getTrackingStateRaw = (state) => state.tracking || {};
exports.getTrackingStateRaw = getTrackingStateRaw;
//# sourceMappingURL=trackingSelector.js.map